"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.showFiltersModal = showFiltersModal;
exports.hideFiltersModal = hideFiltersModal;
exports.setIsSearched = setIsSearched;
exports.loadMoreCUList = loadMoreCUList;
exports.reloadCUList = reloadCUList;
exports.setMajorName = setMajorName;
exports.setStartY = setStartY;
exports.setDoLocation = setDoLocation;
exports.toggleFilter = toggleFilter;
exports.resetFilter = resetFilter;
exports.setYear = setYear;
exports.init = init;
var LOAD_MORE_CULIST = "major/culist/LOAD_MORE_CULIST";
var LOAD_MORE_CULIST_SUCCESS = "major/culist/LOAD_MORE_CULIST_SUCCESS";
var LOAD_MORE_CULIST_FAIL = "major/culist/LOAD_MORE_CULIST_FAIL";

var RELOAD_CULIST = "major/culist/RELOAD_CULIST";
var RELOAD_CULIST_SUCCESS = "major/culist/RELOAD_CULIST_SUCCESS";
var RELOAD_CULIST_FAIL = "major/culist/RELOAD_CULIST_FAIL";

var GET_FILTERS = "major/culist/GET_FILTERS";
var GET_FILTERS_SUCCESS = "major/culist/GET_FILTERS_SUCCESS";
var GET_FILTERS_FAIL = "major/culist/GET_FILTERS_FAIL";

var TOGGLE_FILTER = "major/culist/TOGGLE_FILTER";
var RESET_FILTER = "major/culist/RESET_FILTER";
var SET_STARTY = 'major/culist/SET_STARTY';
var SET_DO_LOCATION = 'major/culist/SET_DO_LOCATION';
var SET_MAJORNAME = 'major/culist/SET_MAJORNAME';
var SET_ISSEARCHED = 'major/culist/SET_ISSEARCHED';
var SET_YEAR = '/subject/culist/SET_YEAR';

var SHOW_FILTER = '/subject/culist/SHOW_FILTER';
var HIDE_FILTER = '/subject/culist/HIDE_FILTER';

var initialState = {
    errorMessage: null,
    filters: [],
    selectedFilters: {},
    pager: {},
    culist: [],
    majorName: '',
    isSearched: false,
    isFiltered: false,
    hasInited: false,
    doLocation: false,
    startY: 0,
    loading: false,
    year: '',
    showFilters: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case LOAD_MORE_CULIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var _res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                _res.culist = _res.culist.concat(action.result.data.data);
                return _res;
            }
        case RELOAD_CULIST:
            return _extends({}, state, {
                loading: true
            });
        case RELOAD_CULIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    pager: null,
                    culist: [],
                    isSearched: true,
                    isFiltered: false,
                    hasInited: true,
                    loading: false
                });
            }
            if (action.params.isFiltered) {
                return _extends({}, state, {
                    pager: action.result.data.pager,
                    culist: action.result.data.data,
                    isSearched: true,
                    isFiltered: true,
                    hasInited: true,
                    loading: false
                });
            }
            return _extends({}, state, {
                pager: action.result.data.pager,
                culist: action.result.data.data,
                isSearched: true,
                isFiltered: false,
                hasInited: true,
                loading: false
            });
        case RELOAD_CULIST_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case GET_FILTERS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                filters: action.result.data.data
            });
        case TOGGLE_FILTER:
            {
                var res = JSON.parse(JSON.stringify(state));
                var selectedFilters = res.selectedFilters[action.filterType];
                selectedFilters = selectedFilters ? selectedFilters : [];
                var i = selectedFilters.map(function (sf) {
                    return sf.id;
                }).indexOf(action.filter.id);
                i > -1 ? selectedFilters.splice(i, 1) : selectedFilters.push(action.filter);
                res.selectedFilters[action.filterType] = selectedFilters;
                return _extends({}, state, {
                    selectedFilters: res.selectedFilters
                });
            }
        case RESET_FILTER:
            return _extends({}, state, {
                selectedFilters: {},
                isFiltered: false
            });
        case SET_MAJORNAME:
            return _extends({}, state, {
                majorName: action.majorName
            });
        case SET_ISSEARCHED:
            return _extends({}, state, {
                isSearched: action.isSearched
            });
        case SET_DO_LOCATION:
            return _extends({}, state, {
                doLocation: action.doLocation
            });
        case SET_STARTY:
            return _extends({}, state, {
                startY: action.startY
            });
        case SET_YEAR:
            return _extends({}, state, {
                year: action.year
            });
        case SHOW_FILTER:
            return _extends({}, state, {
                showFilters: true
            });
        case HIDE_FILTER:
            return _extends({}, state, {
                showFilters: false
            });
        default:
            return state;
    }
}
function showFiltersModal() {
    return {
        type: SHOW_FILTER
    };
}

function hideFiltersModal() {
    return {
        type: HIDE_FILTER
    };
}
function setIsSearched(value) {
    return {
        type: SET_ISSEARCHED,
        isSearched: value
    };
}

function _reloadCUList(params) {
    return {
        types: [RELOAD_CULIST, RELOAD_CULIST_SUCCESS, RELOAD_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post("/api/major/cu_list", params);
            }

            return promise;
        }(),
        params: params
    };
}

function _loadMoreCUList(params, callback) {
    return {
        types: [LOAD_MORE_CULIST, LOAD_MORE_CULIST_SUCCESS, LOAD_MORE_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post("/api/major/cu_list", params);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _getFilters() {
    return {
        types: [GET_FILTERS, GET_FILTERS_SUCCESS, GET_FILTERS_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/major/filter");
            }

            return promise;
        }()
    };
}

function _createQuery(_ref) {
    var _ref$majorName = _ref.majorName,
        majorName = _ref$majorName === undefined ? '' : _ref$majorName,
        pager = _ref.pager,
        selectedFilters = _ref.selectedFilters,
        year = _ref.year;

    if (pager && pager.page && pager.page >= pager.totalPages) {
        return;
    }

    var params = {
        majorName: majorName,
        page: pager && pager.page ? pager.page + 1 : 1,
        size: pager && pager.size ? pager.size : 10,
        year: year
    };
    params["isFiltered"] = false;
    if (null != params["majorName"] && "" != params["majorName"]) {
        params["isFiltered"] = true;
    }
    Object.keys(selectedFilters).map(function (key) {
        var filters = selectedFilters[key];
        if (!filters || filters.length == 0) {
            return;
        } else {
            params["isFiltered"] = true;
        }
        var ids = filters.map(function (filter) {
            return filter.id;
        });
        params[key + "Ids"] = ids;
    });
    return params;
}

function loadMoreCUList(callback) {
    return function (dispatch, getState) {
        var query = _createQuery(getState().majorCUList);
        if (!!query) {
            dispatch(_loadMoreCUList(query, callback));
        }
    };
}

function reloadCUList() {
    return function (dispatch, getState) {
        var state = getState().majorCUList;
        state.pager = null;
        var query = _createQuery(state);
        dispatch(_reloadCUList(query));
    };
}

function setMajorName(majorName) {
    return {
        type: SET_MAJORNAME,
        majorName: majorName
    };
}

function setStartY(y) {
    return {
        type: SET_STARTY,
        startY: y
    };
}

function setDoLocation(value) {
    return {
        type: SET_DO_LOCATION,
        doLocation: value
    };
}

function toggleFilter() {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return {
        type: TOGGLE_FILTER,
        filterType: filterType,
        filter: filter
    };
}

function resetFilter() {
    return {
        type: RESET_FILTER
    };
}

function setYear(year) {
    return {
        type: SET_YEAR,
        year: year
    };
}
function init(majorName) {
    return function (dispatch, getState) {
        dispatch(setMajorName(majorName ? majorName : ''));
        dispatch(_getFilters());
    };
}
// export function init(majorName, year, mustInit = false) {
//     return (dispatch, getState) => {
//         if (mustInit) {
//             dispatch(setMajorName(majorName ? majorName : ''));
//             dispatch(setYear(year));
//             dispatch(reloadCUList());
//             dispatch(_getFilters());
//             dispatch(setDoLocation(false));
//             dispatch(setStartY(0));
//         } else {
//             if (!getState().majorCUList.hasInited) {
//                 dispatch(setMajorName(majorName ? majorName : ''));
//                 dispatch(setYear(year));
//                 dispatch(reloadCUList());
//                 dispatch(_getFilters());
//                 dispatch(setDoLocation(false));
//                 dispatch(setStartY(0));
//             } else {
//                 dispatch(setDoLocation(true));
//             }
//         }
//     }
// }


//////////////////
// WEBPACK FOOTER
// ./src/reducers/major/majorCUList.js
// module id = 489
// module chunks = 0